/* global gtag_report_conversion */
import React from "react";
import { FiPhone } from "react-icons/fi";
import "../styles/footer.css";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { ReactComponent as Logo } from "../images/logo.svg";

const Footer = () => {
  return (
    <footer className="custom-footer py-5" id="contact">
      <div className="container">
        <div className="footer-overlay" aria-hidden="true" />
        <div className="row text-center text-md-center justify-content-center align-items-center g-4">
          <div className="col-md-4 mb-4 mb-md-0 d-flex flex-column align-items-center">
            <div className="map-responsive">
              <iframe
                title="0–24 akkumulátor bikázás Pest, Kiskunlacháza, Rákóczi út 125, 2340"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2711.58530324026!2d19.02149247677461!3d47.18555541695734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741f73b6c0e4a41%3A0x5c468c701aaa944f!2zMOKAkzI0IGFra3VtdWzDoXRvciBiaWvDoXrDoXMgUGVzdA!5e0!3m2!1shu!2shu!4v1760018217498!5m2!1shu!2shu"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Call to action */}
          <div className="col-md-4 d-flex flex-column align-items-center">
            <h5 className="footer-title pb-3">Sürgős segítség?</h5>
            <a
              href="tel:+36206282000"
              className="call-btn px-4 py-2 fs-4 d-inline-flex align-items-center"
              onClick={() => {
                try {
                  if (typeof gtag_report_conversion === "function") {
                    gtag_report_conversion("tel:+36206282000");
                  }
                } catch (err) {
                  console.error("gtag_report_conversion error:", err);
                }
                // no preventDefault → phone app will still open
              }}
            >
              <FiPhone className="me-2" />
              +36 20 628 2000
            </a>

            <p className="footer-hours mt-3">Éjjel-nappal elérhető • 0–24</p>
            <p className="footer-note">
              Lemerült akkumulátor? Indítunk pár perc alatt.
            </p>
          </div>

          {/* Social & legal */}
          <div className="col-md-4 d-flex flex-column align-items-center">
            <div className="footer-logo-div">
              <a href="#" aria-label="Facebook">
                <Logo className="footer-logo" />
              </a>
            </div>
            <a href="/impresszum" className="footer-link">
              Impresszum
            </a>
            <a href="/adatvedelem" className="footer-link mt-2">
              Adatkezelési tájékoztató
            </a>
          </div>
        </div>

        <div className="text-center text-company small mt-4">
          © {new Date().getFullYear()} Sempy & Dani Car Kft. Minden jog
          fenntartva.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
